import React, { useState } from "react";
import styled from "styled-components";
import Identity from "./Identity";
import Accounts from "./Accounts";
import Transactions from "./Transactions";
// import Payments from "./Payments";
import Insights from './Insights';
import Colors from "../theme/colors";
import backBtn from "../images/arrow-back.png";

const Navigation = styled.div`
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  background-color: #f4f5f5;
  position: sticky;
  top: 0;
`;

const Top = styled.div`
  box-sizing: border-box;
  max-width: 1152px;
  height: 64px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    margin: 0;
  }

  h2 {
    font-weight: 600;
    font-size: 16px;
    margin: 0;
  }
`;

const ScrollableOuter = styled.div`
  box-sizing: border-box;
  width: 100%;

  background-color: white;
  border-top: 0.5px solid #e4e7e7;
  border-bottom: 0.5px solid #e4e7e7;
  padding: 14px 24px;
  overflow-x: scroll;

  ul {
    margin: auto;
    max-width: 1152px;
    padding: 0;

    li {
      display: inline-block;
    }
  }
`;

const NavBtn = styled.button`
  padding: 0;
  color: ${(props) => (props.active ? Colors.Trust.Primary : "#081717")};
  background-color: transparent;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  margin: 0 40px 0 0;
  transition: background-color 300ms;
`;

const View = styled.div`
  background-color: #fcfcfc;
`;

const NameBlock = styled.div`
  display: block;
  max-width: 1152px;
  margin: auto;
  padding: 24px;
  background-color: #fcfcfc;
  font-weight: 600;
  font-size: 24px;
`;

const RstBtn = styled.button`
  color: ${Colors.Trust.Primary};
  background-color: rgba(255, 255, 255, 0);
  border: none;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const BackIcn = styled.img`
  width: 8px;
  height: 8px;
  margin: auto;
`;

const Connected = ({
  selectedBank,
  setConnected,
  appIcon,
  applicationName,
  country
}) => {
  const [currentState, updateCurrentState] = useState("ACCOUNTS");

  return (
    <View>
      <div style={{ width: "100%" }}>
        <Navigation>
          <Top>
            <div>
              <RstBtn onClick={() => setConnected(false)}>
                <BackIcn
                  src={backBtn}
                  style={{ width: "18px", height: "18px" }}
                  alt="reset"
                />
                Restart
              </RstBtn>
            </div>
            <h2>{applicationName}</h2>
            <img alt="appIcon" src={appIcon} />
          </Top>
          <ScrollableOuter>
            <ul>
              <li>
                <NavBtn
                  onClick={() => updateCurrentState("ACCOUNTS")}
                  active={currentState === "ACCOUNTS"}
                >
                  Accounts
                </NavBtn>
              </li>
              <li>
                <NavBtn
                  onClick={() => updateCurrentState("TRANSACTIONS")}
                  active={currentState === "TRANSACTIONS"}
                >
                  Transactions
                </NavBtn>
              </li>
              {country !== "SAU" &&
                <li>
                  <NavBtn
                    onClick={() => updateCurrentState("KYC")}
                    active={currentState === "KYC"}
                  >
                    Identity
                  </NavBtn>
                </li>
              }
              {/* <li>
                <NavBtn 
                  onClick={() => updateCurrentState('PAYMENTS')} 
                  active={currentState === 'PAYMENTS'}>
                    Payments
                </NavBtn>
              </li> */}
              <li>
                <NavBtn 
                  onClick={() => updateCurrentState('INSIGHTS')} 
                  active={currentState === 'INSIGHTS'}>
                    Insights
                </NavBtn>
              </li>
            </ul>
          </ScrollableOuter>
        </Navigation>
        <NameBlock>Cloud Strife</NameBlock>

        {currentState === "KYC" && <Identity />}
        {currentState === "ACCOUNTS" && <Accounts currentBank={selectedBank} country={country} />}
        {currentState === "TRANSACTIONS" && (
          <Transactions currentBank={selectedBank} country={country} />
        )}
        {currentState === "INSIGHTS" && (
          <Insights />
        )}
      </div>
    </View>
  );
};

export default Connected;
